export const PORT_MAP = new WeakMap();
//# sourceMappingURL=port-map.js.map